import relps from "@/data/forms/mixins/relps.js";
export default {
  mixins: [relps],
  methods: {
    defineRelps(tag) {
      let relps = null;
      if (tag === "A1") {
        relps = this.formRelpsAsset;
      }
      if (tag === "B1" || tag === "S6") {
        relps = this.formRelpsIncidentRisk;
      }
      if (tag === "B3") {
        relps = this.formRelpsAction;
      }
      if (tag === "B4") {
        relps = this.formRelpsBudget;
      }
      if (tag === "B6") {
        relps = this.formRelpsPlan;
      }
      if (tag === "C1") {
        relps = this.formRelpsCompany;
      }
      if (tag === "E1") {
        relps = this.formRelpsEquipment;
      }
      if (tag === "E2") {
        relps = this.formRelpsEngineering;
      }
      if (tag === "E6") {
        relps = this.formRelpsProgram;
      }
      if (tag === "E8") {
        relps = this.formRelpsProgram;
      }
      if (tag === "F1") {
        relps = this.formRelpsFacility;
      }
      if (tag === "L1") {
        relps = this.formRelpsMaterial;
      }
      if (tag === "M2") {
        relps = this.formRelpsMaintStrategy;
      }
      if (tag === "M5") {
        relps = this.formRelpsMaintPlan;
      }
      if (tag === "O1") {
        relps = this.formRelpsNotification;
      }
      if (tag === "Q1") {
        relps = this.formRelpsOrder;
      }
      if (tag === "S1") {
        relps = this.formRelpsHazard;
      }
      if (tag === "U1") {
        relps = this.formRelpsUser;
      }
      if (tag === "W1") {
        relps = this.formRelpsWorkRequest;
      }
      if (tag === "W2") {
        relps = this.formRelpsWorkCall;
      }
      if (tag === "W6") {
        relps = this.formRelpsProcedure;
      }
      return relps;
    }
  }
};
